import React from 'react'
import roles, { allRoles } from 'keys/roles'
import { join, map, slice, sortBy } from 'lodash'
import { Tooltip } from '@mui/material'

const UserRolesCell = (props) => {
    const { getValue, row } = props
    let userRoles = getValue()
    let value = ""
    let tooltip = ""

    // מקבלים את סוג התפקיד: תקפיד ברמת בית ספר, שכבה , כיתה, יחידני 
    const roleType = allRoles[row.original.role.name]

    if (roleType == roles.principal)
        value = "כל בית הספר"

    else if (roleType == roles.coordinator) {
        userRoles = sortBy(userRoles, user => user.grade)

        const maxDisplay = 3
        const displayedGrades = map(userRoles, "grade_name")
        const firstThreeGrades = displayedGrades.slice(0, maxDisplay)
        const remainingCount = userRoles.length - maxDisplay

        if (firstThreeGrades.length) {
            value += 'שכבה'
            tooltip = join(displayedGrades, ', ')
        }
        value += join(firstThreeGrades, ', ')
        if (remainingCount > 0)
            value += ` + ${remainingCount} שכבות`
    }

    else if (roleType == roles.teacher) {
        userRoles = sortBy(userRoles, user => user.grade)
        const maxDisplay = 3
        const displayedClasses = map(userRoles, obj => `${obj["grade_name"]}${obj["learning_unit_name"]}`)
        const firstThreeClasses = displayedClasses.slice(0, maxDisplay)
        const remainingCount = userRoles.length - maxDisplay

        tooltip = join(displayedClasses, ', ')
        value = join(firstThreeClasses, ', ')
        if (remainingCount > 0)
            value += ` + ${remainingCount} כיתות`
    }

    else if (roleType == roles.single) {
        let testTakers = map(userRoles, ur => `${ur.test_taker_name} - ${ur.grade_name}${ur.learning_unit_name}`)
        tooltip = join(testTakers, ', ')
        value = `${userRoles.length} תלמידים`
    }

    return (
        <Tooltip title={tooltip}>
            {value}
        </Tooltip>
    )
}

export default UserRolesCell